<template>
  <div class="pa-0 ma-0">
    <v-subheader class="mb-1 ml-0 pl-0" style="height: auto">
      {{ $t("room.illumination.preconditions") }}
    </v-subheader>

    <niko-textarea
      :rows="1"
      :value="test.test_requirements"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'test_requirements',
            newValue: value,
          };
          changeIlluminationTestAttribute(options);
        }
      "
      :placeholder="$t('room.illumination.preconditions')"
    />

    <h4>{{ $t("room.illumination.illuminance.title") }}</h4>

    <niko-slider
      :label="$t('room.illumination.illuminance.required')"
      :min="0"
      :max="1500"
      suffix="lux"
      step="1"
      :value="test.average_illuminance"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'average_illuminance',
            newValue: value,
          };

          changeIlluminationTestAttribute(options);
        }
      "
    ></niko-slider>

    <niko-slider
      :label="$t('room.illumination.illuminance.deviation')"
      :subLabel="$t('room.illumination.illuminance.deviation_info')"
      :min="0"
      :max="100"
      suffix="%"
      step="1"
      :value="test.illuminance_deviation"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'illuminance_deviation',
            newValue: value,
          };

          changeIlluminationTestAttribute(options);
        }
      "
    ></niko-slider>

    <h4>{{ $t("room.illumination.uniformity.title") }}</h4>

    <niko-slider
      :label="$t('room.illumination.uniformity.required')"
      :min="0"
      :max="1"
      suffix="U0"
      step="0.1"
      :accuracy="0.1"
      :value="test.uniformity"
      textFieldType="text"
      @onChange="
        (valueObj) => {
          const options = {
            index,
            attribute: 'uniformity',
            newValue: Math.round(valueObj.value * 10) / 10,
          };
          changeIlluminationTestAttribute(options);
        }
      "
    ></niko-slider>

    <v-btn icon class="mb-6" @click="deleteIlluminationTest(index)"
      ><v-icon>$iconDelete</v-icon></v-btn
    >
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import NikoTextarea from "../UI/NikoTextarea";
import NikoSlider from "../UI/NikoSlider";

export default {
  name: "illumination-test-details",
  components: { NikoSlider, NikoTextarea },
  props: ["test", "index"],
  methods: {
    ...mapMutations("roomStore", [
      "changeIlluminationTestAttribute",
      "deleteIlluminationTest",
    ]),
  },
};
</script>
